'use client';

import { Button } from '@ahafood/ui/components/button';
import { Loader2, LogIn } from 'lucide-react';
import { useState } from 'react';
import { LoginDialog } from '@/app/[locale]/(main)/store/components/fb-login';
import { ROUTES } from '@/config/router';
import { Link } from '@/i18n/routing';
import { useAuthStore } from '@/store/use-auth-store';

export default function UserButton() {
  const { user, isAuthenticated, isLoading } = useAuthStore();
  const [showLoginDialog, setShowLoginDialog] = useState(false);

  if (isLoading) {
    return (
      <Button
        variant="outline"
        className="flex items-center justify-center rounded-xl size-10 h-12 md:h-14 min-w-fit text-brand-primary border-brand-primary bg-white/80 hover:bg-brand-primary hover:text-white transition-colors font-bold"
      >
        <Loader2 className="size-5 md:size-6 text-brand-primary animate-spin" />
      </Button>
    );
  }

  if (!isAuthenticated || !user) {
    return (
      <>
        <Button
          variant="outline"
          size="icon"
          onClick={(e) => {
            e.stopPropagation();
            setShowLoginDialog(!showLoginDialog);
          }}
          className="flex items-center justify-center size-10 md:rounded-xl rounded-full md:h-14 min-w-fit font-bold text-brand-primary border-brand-primary bg-white/80 hover:bg-brand-primary hover:text-white transition-colors"
          aria-label="Đăng nhập"
        >
          <LogIn />
        </Button>
        <LoginDialog
          open={showLoginDialog}
          onOpenChange={setShowLoginDialog}
          location="header_button"
        />
      </>
    );
  }

  return (
    <Link href={ROUTES.user} className="flex items-center md:pr-4">
      <div className="relative flex size-10 md:size-13 shrink-0 overflow-hidden rounded-full hover:border-2 border-brand-primary group-hover:border-neutral-30 transition-colors">
        {user.picture ? (
          <img
            className="aspect-square size-full object-contain"
            src={user.picture}
            alt={user.name}
          />
        ) : (
          <div className="flex size-full items-center justify-center bg-primary-10 text-sm font-semibold text-primary-50">
            {user.name.charAt(0).toUpperCase()}
          </div>
        )}
      </div>
    </Link>
  );
}
